import {
    useMutation,
    UseMutationResult,
} from '@tanstack/react-query'
import {
    useJWTToken,
} from 'app/Auth'

import useHandleStatusRequest from 'app/hooks/useHandleStatusRequest'

import requests from 'app/requests/Order/OrderBilling.requests'
import simpleApi from 'app/services/simpleApi'

type RequestParams = {
    orderNumber: string,
    data: {id: number},
}

const useRelinkAdditionalFee = (onSuccess: () => void)
    : UseMutationResult<unknown, unknown, RequestParams> => {
    const token = useJWTToken()
    const {
        onSuccess: onSuccessRelinkAdditionalFee,
        onError,
    } = useHandleStatusRequest({
        id: 'relinkAdditionalFee',
        title: 'Relink Additional Fee',
        onSuccess,
    })

    return useMutation({
        mutationFn: ({
            orderNumber,
            data,
        }: RequestParams) => {
            return simpleApi({
                ...requests.updateAdditionalFees({
                    orderNumber,
                    data,
                }),
                token,
            })
        },
        onSuccess: onSuccessRelinkAdditionalFee,
        onError,
    })
}

export default useRelinkAdditionalFee
